export default { latitude: 'latitude', longitude: 'longitude' }
